var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"card-default"},[_c('v-card-title',{staticClass:"card-title text--primary mb-0 pb-0"},[_vm._v(" Live Keogram ")]),_c('v-card-text',{staticClass:"card-text text--primary"},[_c('v-img',{attrs:{"src":_vm.keogramURL}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }